import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderState } from '../../models/loader-state';
import { ApiLoaderService } from '../../services/api-loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'api-loader',
  imports: [CommonModule],
  templateUrl: './api-loader.component.html',
  styleUrl: './api-loader.component.scss'
})
export class ApiLoaderComponent {
  show = false;
  private subscription: Subscription;

  constructor(private loaderService: ApiLoaderService) {
    this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
      this.show = state.show;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
